import { render, staticRenderFns } from "./CmgCheckoutBadPhoneNumberModal.vue?vue&type=template&id=56a098e0&scoped=true&lang=pug&"
import script from "./cmg-checkout-bad-phone-number-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-bad-phone-number-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutBadPhoneNumberModal.vue?vue&type=style&index=0&id=56a098e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a098e0",
  null
  
)

export default component.exports